<template>
	<form id="add-domain-form" novalidate class="needs-validation" :class="{'was-validated':hasError}" v-on:submit.prevent="saveForm">

		<error :error="error"></error>	

		<div class="form-row">
			<div class="col-sm-6">
				<div v-if="!isEmailRoute" class="m-t pl-3 pr-3 form-group required">
					<label class="control-label required font-weight-bold" for="user-name">User Name</label>
					<input id="user-name" class="form-control" placeholder="" v-model="userName"/>
				</div>
			</div>
			<div class="col-sm-6">
				<div v-if="!isEmailRoute" class="m-t pl-3 pr-3 form-group required">
					<label class="control-label required font-weight-bold" for="user-status-select">User Status</label>
					<select id="user-status-select" class="form-control custom-select" v-model="userStatus">
						<option value=""></option>
						<option value="1">Enabled</option>
						<option value="2">Disabled</option>
						<option value="3">Expired</option>
						<option value="4">Deleted</option>
					</select>
				</div>
			</div>
		</div>
			
		<div class="clearfix mt-1 mb-3">
			<div class="float-left ml-3">
				<button v-if="isEmailRoute" type="button" class="btn btn-outline-primary px-3" @click="openModal">Remove Email</button>
			</div>
			<div class="float-right mr-3">
				<button v-if="!isEmailRoute" type="submit" class="btn btn-outline-primary px-3">Update</button>
				<button type="button" class="btn btn-outline-primary px-3" @click="closeForm">Cancel</button>
			</div>
		</div>

		<modal id="remove-email-modal" :visible="showModal" modalId="remove-email-modal" confirm="Remove" title="Confirm Remove Email" @confirm="confirmModal" @cancel="cancelModal">
			<p class="mt-3">Are you sure you wish to remove this email?</p>
		</modal>

	</form>
</template>

<script>
	import Modal from './Modal'
	import Error from './Error'

	import api from '../api'
	import store from '../state'
	import router from '../router'

	export default {
		name: 'EditEmailDetailForm',
		components: {Error, Modal},
		props: ['name','email'],
		data() {
			return {
				userName: this.email && this.email.userName,
				userStatus: this.email && this.email.userStatus,
				error: '',
				showModal: false
			}
		}		,
		computed: {
			hasError() {
				return false;
			},
			showRemove() {
				return true;
			},
			isEmailRoute() {
				return router.currentRoute.name === 'emailDetail'
			}
		},
		methods: {
			openModal() {
				this.showModal = true;
			},
			cancelModal() {
				this.showModal = false;
			},
			confirmModal() {
				this.showModal = false;
				this.removeEmail();				
			},
			closeForm() {
				this.$emit('close-edit-email');
			},
			async saveForm() {
				
				try
				{
					const response = await api.put(`domain/email/${this.name}`, {userName:this.userName, userStatus:this.userStatus || 0});	

					//Update the email object passed in the prop 
					this.email.userName = this.userName;
					this.email.userStatus = this.userStatus;

					this.closeForm();
				}
				catch(err) {
					this.error = err;	
				}
			},
			async removeEmail() {
				try
				{
					var response = await api.delete(`/email/${this.name}`);	
					store.dispatch('getEmailsAsync');
					this.closeForm();

					//Navigate to the emails view
					router.push({name: 'emails'});
				}
				catch(err) {				
					this.error = err;
				}
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/EditEmailDetailForm.vue